import ApiFactory from '../api/ApiFactory';

class Service {
  getApiFactory () {
    return ApiFactory.getInstance();
  }

  getLoginApi () {
    return this.getApiFactory().getLoginApi();
  }

  getChangelogApi () {
    return this.getApiFactory().getChangelogApi();
  }

  getVersaoSistemaApi () {
    return this.getApiFactory().getVersaoSistemaApi();
  }

  getBeneficiarioApi () {
    return this.getApiFactory().getBeneficiarioApi();
  }

  getParametroApi () {
    return this.getApiFactory().getParametroApi();
  }

  getCreditoApi () {
    return this.getApiFactory().getCreditoApi();
  }

  getCarenciaApi () {
    return this.getApiFactory().getCarenciaApi();
  }

  getExtratoApi () {
    return this.getApiFactory().getExtratoApi();
  }

  getPrestadorApi () {
    return this.getApiFactory().getPrestadorApi();
  }

  getAnexoApi () {
    return this.getApiFactory().getAnexoApi();
  }

  getArquivoXMLApi () {
    return this.getApiFactory().getArquivoXMLApi();
  }

  getFaturaApi () {
    return this.getApiFactory().getFaturaApi();
  }

  getGuiaApi () {
    return this.getApiFactory().getGuiaApi();
  }

  getTipoAtendimentoApi () {
    return this.getApiFactory().getTipoAtendimentoApi();
  }

  getTipoSituacaoServidorApi () {
    return this.getApiFactory().getTipoSituacaoServidorApi();
  }

  getDividasEmAbertoApi () {
    return this.getApiFactory().getDividasEmAbertoApi();
  }

  getElementoApi () {
    return this.getApiFactory().getElementoApi();
  }
  getUsuarioApi () {
    return this.getApiFactory().getUsuarioApi();
  }
  getGlosaApi () {
    return this.getApiFactory().getGlosaApi();
  }
  getCepApi () {
    return this.getApiFactory().getCepApi();
  }
  getTelefoneApi () {
    return this.getApiFactory().getTelefoneApi();
  }
  getOrgaoExternoApi () {
    return this.getApiFactory().getOrgaoExternoApi();
  }
  getBancoApi () {
    return this.getApiFactory().getBancoApi();
  }
  getAgenciaApi () {
    return this.getApiFactory().getAgenciaApi();
  }
  getProcessoApi () {
    return this.getApiFactory().getProcessoApi();
  }
  getContratoApi () {
    return this.getApiFactory().getContratoApi();
  }
  getDemonstrativoApi () {
    return this.getApiFactory().getDemonstrativoApi();
  }
  getProdutividadeApi () {
    return this.getApiFactory().getProdutividadeApi();
  }
  getProfissionalApi () {
    return this.getApiFactory().getProfissionalApi();
  }
  getUfApi () {
    return this.getApiFactory().getUfApi();
  }
  getFaixaRemuneracaoApi () {
    return this.getApiFactory().getFaixaRemuneracaoApi();
  }
  getFaixaEtariaApi () {
    return this.getApiFactory().getFaixaEtariaApi();
  }
  getTipoMensalidadeApi () {
    return this.getApiFactory().getTipoMensalidadeApi();
  }
  getMensalidadeApi () {
    return this.getApiFactory().getMensalidadeApi();
  }
  getLimiteCobrancaApi () {
    return this.getApiFactory().getLimiteCobrancaApi();
  }
  getCalculoCoparticipacaoApi () {
    return this.getApiFactory().getCalculoCoparticipacaoApi();
  }
  getPensionistaApi () {
    return this.getApiFactory().getPensionistaApi();
  }
  getAcertoMensalidadeApi () {
    return this.getApiFactory().getAcertoMensalidadeApi();
  }
  getAcertoCoparticipacaoApi () {
    return this.getApiFactory().getAcertoCoparticipacaoApi();
  }
  getAcertosDiversosApi () {
    return this.getApiFactory().getAcertosDiversosApi();
  }
  getItemTabelaApi () {
    return this.getApiFactory().getItemTabelaApi();
  }
  getDividaServDesligadoApi () {
    return this.getApiFactory().getDividaServDesligadoApi();
  }  
  getDividaServDesligadoPagtoApi () {
    return this.getApiFactory().getDividaServDesligadoPagtoApi();
  }  
  getCalculoAtuarialApi () {
    return this.getApiFactory().getCalculoAtuarialApi();
  }  
  getRelatorioBeneficiariosApi () {
    return this.getApiFactory().getRelatorioBeneficiariosApi();
  }  
  getDeclaracaoDeGastosApi () {
    return this.getApiFactory().getDeclaracaoDeGastosApi();
  }  
  getReembolsoMedicoApi () {
    return this.getApiFactory().getReembolsoMedicoApi();
  }  
  getAssistenciaOdontoApi () {
    return this.getApiFactory().getAssistenciaOdontoApi();
  }  
  getRelatorioReembolsoApi () {
    return this.getApiFactory().getRelatorioReembolsoApi();
  }  
  getVigenciaPorteApi () {
    return this.getApiFactory().getVigenciaPorteApi();
  }  
}

export default Service;
